import { EvtHeader } from "components/header";
import MilestoneForm from "@/modules/work/milestones/form";
import { useMilestone } from "@/modules/work/milestones/context";

const UpdateMilestone = () => {
  const { type } = useMilestone();
  return (
    <div className="flex-1">
      <EvtHeader title="Edit Milestone" />
      <div className="p-6 max-w-md">
        <MilestoneForm type={type} />
      </div>
    </div>
  );
};

export default UpdateMilestone;
